module.exports = __webpack_public_path__ + "493b743ed9ee3aada0d0f03f43ad3c37.svg";